import type { Tone } from "@/lib/format";

/* Pigułka statusu: ramka w kolorze tonu na 40%, tło na 10%, w środku
   etykieta tekstowa. Kolor nigdy nie występuje sam - to wymóg dostępności,
   nie estetyka. Ton "neutral" nie ma własnej barwy, bo "nic się nie dzieje"
   nie jest stanem, który trzeba podświetlić. */
const TONES: Record<Tone, string> = {
  ok: "border-success/40 bg-success/10 text-success",
  warn: "border-warning/40 bg-warning/10 text-warning",
  error: "border-error/40 bg-error/10 text-error",
  neutral: "border-line bg-bg text-ink-soft",
};

export function Badge({ tone, children }: { tone: Tone; children: string }) {
  return (
    <span
      className={`inline-block whitespace-nowrap rounded-pill border px-2.25 py-0.75 text-xs ${TONES[tone]}`}
    >
      {children}
    </span>
  );
}
